webpackJsonp([178469467687848],{

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/404.14e090e2.svg";

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var button_1 = __webpack_require__(34);
	__webpack_require__(706);
	var img404 = __webpack_require__(852);
	
	var NotFound = function (_React$Component) {
	    _inherits(NotFound, _React$Component);
	
	    function NotFound() {
	        _classCallCheck(this, NotFound);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    NotFound.prototype.render = function render() {
	        return React.createElement("div", { className: "not-found" }, React.createElement(button_1.default, { extraClasses: "btn--arrow-right", to: "/", content: "Back to Homepage" }), React.createElement("div", { className: "not-found__image" }, React.createElement("picture", null, React.createElement("img", { src: img404, alt: "Not Found" }))));
	    };
	
	    return NotFound;
	}(React.Component);
	
	exports.default = NotFound;

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(2);
	var _404_1 = __webpack_require__(332);
	var basic_layout_1 = __webpack_require__(21);
	
	var NotFoundPage = function (_React$Component) {
	    _inherits(NotFoundPage, _React$Component);
	
	    function NotFoundPage() {
	        _classCallCheck(this, NotFoundPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    NotFoundPage.prototype.componentDidMount = function componentDidMount() {
	        analytics.page("404");
	    };
	
	    NotFoundPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(basic_layout_1.default, { heroTitle: "Oops! Seems you got lost", heroSubtitle: "The page you are looking for can\u2019t be found.", showIntegrations: false, showFooter: false, showCta: false, variableComponent: _404_1.default }));
	    };
	
	    return NotFoundPage;
	}(React.Component);
	
	exports.default = NotFoundPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-tsx-6ae83efc9fbc9826d6de.js